// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1TCcQ","modalFooterButton":"ModalNotes_modalFooterButton__NFbZb"};